export const InsertDriveFileOutlined = () => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 2h8l6 6v12c0 1.1-.9 2-2 2H5.99C4.89 22 4 21.1 4 20l.01-16c0-1.1.89-2 1.99-2Zm0 2v16h12V9h-5V4H6Z"
      fill="currentColor"
    />
  </svg>
);
